
import React from "react";
import { Layout } from "@/components/Layout";
import { AdminDashboardProvider } from "@/contexts/AdminDashboardContext";
import AdminDashboardHeader from "@/components/admin/AdminDashboardHeader";
import AdminDashboardContent from "@/components/admin/AdminDashboardContent";
import AdminDashboardDialogs from "@/components/admin/AdminDashboardDialogs";
import { useSearchParams } from "react-router-dom";

const AdminDashboard: React.FC = () => {
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'bookings';

  return (
    <Layout>
      <AdminDashboardProvider>
        <div className="container py-10">
          <AdminDashboardHeader />
          <AdminDashboardContent defaultTab={defaultTab} />
          <AdminDashboardDialogs />
        </div>
      </AdminDashboardProvider>
    </Layout>
  );
};

export default AdminDashboard;
